export default function BrandIntro() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20peaceful%20zen%20meditation%20room%20with%20warm%20wooden%20interior%2C%20a%20single%20handcrafted%20grass%20lantern%20on%20a%20low%20wooden%20table%2C%20soft%20natural%20light%20from%20paper%20window%2C%20minimalist%20Japanese%20aesthetic%2C%20calligraphy%20scroll%20on%20wall%2C%20warm%20earthy%20tones%2C%20serene%20atmosphere&width=800&height=600&seq=brand-intro-01&orientation=landscape"
                alt="草灯和尚 - 禅意空间"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:w-1/2">
            <p className="text-primary-600 text-sm font-medium tracking-wider mb-3">
              品牌故事
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
              一盏草灯，千年禅心
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4">
              草灯和尚，起源于唐代深山古寺中的一位无名僧人。他以山间枯草编织成灯，
              在微弱的光芒中诵读经卷，以最朴素的方式守护内心的光明。
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              这个看似简单的故事，却蕴含着深厚的禅宗智慧——真正的光明不在于外在的华丽，
              而在于内心的觉悟与坚持。一草一木，皆可为灯；一心一念，皆可成佛。
            </p>
            <p className="text-foreground-600 leading-relaxed mb-4">
              今天，草灯和尚已成为一个承载东方禅意与生活美学的文化符号。
              我们致力于传承这份智慧，让更多人在现代生活中感受到"以草为灯、以心照路"
              的精神力量。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}